// extracted by mini-css-extract-plugin
module.exports = {"linkTips":"linkTips_linkTips__fB6BT","inner":"linkTips_inner__dWTvS","tips":"linkTips_tips__MyYe1","link":"linkTips_link__8Layj","linkBtn":"linkTips_linkBtn__8Zt5H"};